import type { TOC } from '@ember/component/template-only';

interface PaymentPaymentMethodRowSignature {
  Args: {
    label: string;
    value: string | undefined;
  };
}

const PaymentPaymentMethodRow: TOC<PaymentPaymentMethodRowSignature> =
  <template>
    <p class="text-300--regular">
      <span class="text-300--bold">{{@label}}</span>{{@value}}
    </p>
  </template>;

export default PaymentPaymentMethodRow;
